import React, { useState } from 'react';

import work_experience from '../data/work_experience.json';
import "../css/Work.css"

import Pagination from './Pagination';
import Arrow from './Arrow';

const Work = () => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const jobToDisplay = work_experience[currentItemIndex];

  return (
    <div className="work">
      <h1>WORK EXPERIENCE</h1>
      <div className="work-experience-entry-container">
        <div className="arrows-container">
          <Arrow 
            direction="left" 
            onClick={() => setCurrentItemIndex(currentItemIndex - 1)} 
            isDisabled={currentItemIndex === 0} 
          />
          <Arrow 
            direction="right" 
            onClick={() => setCurrentItemIndex(currentItemIndex + 1)} 
            isDisabled={currentItemIndex === work_experience.length - 1} 
          />
        </div>
        <div className="work-experience-info">
          <div className="company-date">
            <h2 className="title">{jobToDisplay.title}</h2>
            <h2 className="date">{jobToDisplay.startDate} - {jobToDisplay.endDate ? jobToDisplay.endDate : "Present"}</h2>
          </div>
          <h3 className="location">{jobToDisplay.location}</h3>
          <h3>{jobToDisplay.position}</h3>
          <h4>{jobToDisplay.tools.join(", ")}</h4>
          <ul>{jobToDisplay.description.map(d => <li>{d}</li>)}</ul>
        </div>
        <div className="pagination-container">
          <Pagination
            pages={work_experience.length}
            active={currentItemIndex}
            onClick={setCurrentItemIndex}
          />
        </div>
      </div>
    </div>
  );
}

export default Work;
